package com.milta.feature.team.presentation

sealed interface WebTeamIntent {
    /** Initial load — resolves the enterpriseId then fetches the driver list. */
    data object LoadTeam : WebTeamIntent

    data class UpdateCodeInput(val code: String) : WebTeamIntent

    data object SubmitCode : WebTeamIntent

    data object ClearAddDriverError : WebTeamIntent

    /** Opens the remove confirmation dialog for [driverId] — no removal happens yet. */
    data class RequestRemoval(val driverId: String) : WebTeamIntent

    /** Closes the confirmation dialog without removing anything. */
    data object CancelRemoval : WebTeamIntent

    /** Confirms the dialog — actually removes the driver held in [WebTeamState.pendingRemovalDriverId]. */
    data object ConfirmRemoval : WebTeamIntent
}
